import { useEffect, FC } from 'react';
import { ReleaseTaskPageView } from './ReleaseTaskPageView';
import { useListStore } from './hooks';

export const ReleaseTaskPage: FC = () => {
  const { fetchReleaseTasks } = useListStore();

  useEffect(() => {
    void fetchReleaseTasks();
  }, [fetchReleaseTasks]);

  return <ReleaseTaskPageView />;
};
